/** Public d'une aide — porté par son module. */
export type AssistanceAudience = 'Professor' | 'Student' | 'Admin';

/** Valeur attendue par l'API à l'écriture (1 = professeurs, 2 = élèves, 3 = équipe). */
export const AUDIENCE_VALUE: Record<AssistanceAudience, number> = {
  Professor: 1,
  Student: 2,
  Admin: 3,
};

export interface AssistanceResource {
  id: number;
  title: string;
  description?: string;
  /** Public du module qui contient la ressource. */
  audience: AssistanceAudience;
  moduleId: number;
  /** Position dans le module, à partir de 1. */
  displayOrder: number;
  fileName?: string;
  fileSizeBytes?: number;
  contentType?: string;
  externalUrl?: string;
  hasFile: boolean;
  previewUrl?: string;
  isArchived: boolean;
  createdAt: string;
  updatedAt?: string;
}

/** Un sujet d'aide et sa série, pour un seul public. */
export interface AssistanceModule {
  id: number;
  title: string;
  description?: string;
  audience: AssistanceAudience;
  /** Position parmi les modules du même public, à partir de 1. */
  displayOrder: number;
  isArchived: boolean;
  createdAt: string;
  updatedAt?: string;
  /** La série, dans son ordre. */
  resources: AssistanceResource[];
}

export interface CreateAssistanceResourceDto {
  title: string;
  description?: string;
  moduleId: number;
  /** Position voulue, à partir de 1 ; 0 place à la fin. */
  displayOrder: number;
  objectKey?: string;
  fileName?: string;
  contentType?: string;
  sizeBytes?: number;
  externalUrl?: string;
}

export interface UpdateAssistanceResourceDto {
  title: string;
  description?: string;
  moduleId: number;
  displayOrder: number;
}

export interface UpsertAssistanceModuleDto {
  title: string;
  description?: string;
  audience: number;
  displayOrder: number;
}
